import BlurOnIcon from "@material-ui/icons/BlurOn";
import DistributionChannelList from "./DistributionChannelList";

export default {
  icon: BlurOnIcon,
  list: DistributionChannelList,
};
